import React from 'react';
import { useSelector } from 'react-redux';
import { TableRow, TableCell, Typography, withStyles } from '@material-ui/core';
import {
    getOwnerStripeDataByPropertyId,
    getOwnerReservationsByPropertyId,
} from '../../stores/dashboard/selectors';
import styles from './styles';

const OwnerDashboardChartRow = (props) => {
    const { property, index } = props;
    const reservationData =
        useSelector(getOwnerReservationsByPropertyId(property.propertyId)) ||
        {};
    const stripeData =
        useSelector(getOwnerStripeDataByPropertyId(property.propertyId)) || {};

    // Calculate values for the row
    const grossBookings =
        (reservationData.stripe || 0) +
        (reservationData.fuel_comp || 0) +
        (reservationData.cash || 0);

    const rowStyle = index % 2 === 1 ? { background: '#F5F5F5' } : {};
    return (
        <TableRow style={rowStyle}>
            <TableCell align="left" style={{ paddingLeft: 16 }}>
                <Typography
                    className={props.classes.cellTextStyle}
                    align="left"
                    display="block"
                >
                    {property.propertyName || property.name || property.id}
                </Typography>
            </TableCell>
            <TableCell>
                <Typography
                    className={props.classes.cellTextStyle}
                    align="center"
                >
                    {grossBookings}
                </Typography>
            </TableCell>
            <TableCell>
                <Typography
                    className={props.classes.cellTextStyle}
                    align="center"
                >
                    ${stripeData.revenue || 0}
                </Typography>
            </TableCell>
            <TableCell>
                <Typography
                    className={props.classes.cellTextStyle}
                    align="center"
                >
                    {reservationData.stripe || 0}
                </Typography>
            </TableCell>
            <TableCell>
                <Typography
                    className={props.classes.cellTextStyle}
                    align="center"
                >
                    {reservationData.cash || 0}
                </Typography>
            </TableCell>
            <TableCell>
                <Typography
                    className={props.classes.cellTextStyle}
                    align="center"
                >
                    {reservationData.fuel_comp || 0}
                </Typography>
            </TableCell>
        </TableRow>
    );
};

export default withStyles(styles)(OwnerDashboardChartRow);
